import { TranslatedString } from 'models/translated-string';
import type { UserDbInitWaitEnding } from './after-purchase-reload';

let l_myApp: IMyApp = undefined;
export function setMyApp(app: IMyApp) {
  l_myApp = app;
}
export function getMyApp(): IMyApp {
  return l_myApp;
}

/** Options for MyApp.reloadAppAsync. Lives here so the interface and the implementation share one
 * spelling — app.component.ts imports it from this file, not the other way round. */
export type ReloadAppOptions = { resetToRoot: boolean; clearLocalData?: boolean; };

export interface IMyApp {
  loginCompleteAsync(): Promise<void>;
  /** NEVER returns and NEVER rejects — always reaches location.reload(), then parks. See the
   * comment in MyApp.reloadAppAsync and design-docs/boot-sequence.md. */
  reloadAppAsync(opts: ReloadAppOptions): Promise<void>;
  redirectToLearnMore(): void;
  shouldShowMenu(): boolean;
  gotoDefaultPageAsync(): Promise<void>;
  /** true once the person has finished onboarding and has paid access */
  isFullAppUnlocked(): boolean;
  markAppLoadingAsync(isLoading: boolean): Promise<void>;
  logoutAsync(): Promise<void>;
  /** #4401: start this device's local store over under a fresh name, then reload. Nothing
   * is deleted — see the note in local-store-generation.ts for why a delete cannot be used
   * against a store that is not answering. */
  resetLocalStoreAndReloadAsync(): Promise<void>;
  /** #6788: wait, at most `maxMs`, for the user database's set-up to finish. The
   * purchase-first checkout calls it so its reload does not cut off a brand-new store's
   * first open. */
  whenUserDbInitSettledAsync(maxMs: number): Promise<UserDbInitWaitEnding>;
  openCommunityPage(): Promise<void>;
  setPageTitle(title: TranslatedString): void;
  fatalErrorParams: { type: string; error?: any; canResetLocalStore?: boolean; };
  showChangelogPageNotification: boolean;
  changelogRev: string | undefined;
  /** The "leave the page to take a screenshot, then come back" round trip: the text the
   * user had typed, the page it belongs to, the page to return to, and the captured
   * image. Every rule of that trip lives on this one object — see its own file. */
  screenshotTrip: import('services/screenshot-trip').ScreenshotTrip;
  syncRetryMessage: string;
  markForCheck(): void;
  /** S4 (#3986): resolves once the native SocialLogin plugin init (started
   * concurrently with the auth init at boot) has finished. Await before the
   * first SocialLogin.login call; resolves immediately on web/non-native. */
  whenSocialLoginReadyAsync(): Promise<void>;
  showRetryProgressBar(totalDurationMs: number): void;
  hideScreenshotButton(): void;
  showScreenshotButton(type: any): void;
}
